import { Route } from "react-router";
import * as React from "react";
const AppRoute = ({ component: Component, layout: Layout, path: Path, ...rest }) => {
    return <Route {...rest} render={props => (
        <Layout>
            <Component {...props} />
        </Layout>
    )} />;
};
export default AppRoute;